declare const __VERSION__: string;

export const SDK_VERSION = __VERSION__;
